var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118 123",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 59a8 8 0 0 1-16 0 59 59 0 0 1 97-45V8a8 8 0 1 1 16 0v25a8 8 0 0 1-8 8l-24 3a8 8 0 1 1-2-16l8-1a43 43 0 0 0-71 32Zm23 20a8 8 0 0 1 1 16l-10 1a43 43 0 0 0 72-32 8 8 0 0 1 16 0 59 59 0 0 1-96 46v4a8 8 0 0 1-16 0V89a8 8 0 0 1 8-8l25-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.73557108.svg";
export { ForwardRef as ReactComponent };